import { useTheme } from "@mui/material";
import React from "react";

import MDTypography from "@/components/atoms/MDTypography";

type SectionProps = {
  title?: string;
  description: string;
};

export const Section: React.FC<SectionProps> = ({ title, description }) => {
  const {
    margins: { quarck },
  } = useTheme();

  const containsListItem = (text: string) => /<li>/i.test(text);

  const renderText = (description: string) => {
    if (containsListItem(description)) {
      // Render as a list with dots before <li>
      return (
        <MDTypography variant="body2" style={{ marginBottom: quarck, textAlign: "left" }}>
          {description.split(/<\/?strong>/).map((text, index) => (
            <React.Fragment key={`string-${index}`}>
              {index > 0 && <br />}
              {text.includes("<li>") ? `.${text.replace(/<\/?li>/g, "")}` : text}
            </React.Fragment>
          ))}
        </MDTypography>
      );
    }

    // Render as paragraphs
    return (
      <MDTypography variant="body2" style={{ marginBottom: quarck * 8 }}>
        {description.split("\n").map((text, index) => (
          <React.Fragment key={`string-${index}`}>
            {index > 0 && <br />}
            <MDTypography
              color={text.includes("<strong>") ? "dark" : "text"}
              variant={text.includes("<strong>") ? "subtitle2" : "body2"}
              style={{ fontWeight: text.includes("<strong>") ? "bold" : "normal" }}
            >
              {text.replace(/<\/?strong>/g, "")}
            </MDTypography>
          </React.Fragment>
        ))}
      </MDTypography>
    );
  };

  return (
    <>
      <MDTypography component={"p"} variant="button" fontWeight="bold" mb={3}>
        {title || ""}
      </MDTypography>
      {renderText(description)}
    </>
  );
};
